import styled from 'styled-components';

export default styled.div`
  display: flex;
  align-items: center;

  > :not(:first-child) {
    margin-left: 0.3rem;
  }
`;
